export const isUserUsePhoneDevice = () => {
  const ua = navigator.userAgent;
  return /Mobile|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua);
};
